//
// Generated class AccountingEntryTax
//

/// <reference path="AccountingEntryTax_ManagedObject.ts" />

class AccountingEntryTax extends AccountingEntryTax_ManagedObject
{

}
